import { render } from "./ManagerAds.vue?vue&type=template&id=468b74a2"
import script from "./ManagerAds.vue?vue&type=script&lang=js"
export * from "./ManagerAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__